export { default } from '@mui/system/useMediaQuery';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/useMediaQuery/index.js
// module id = 466
// module chunks = 22